import { gql } from "@apollo/client";
export const GET_PCN_COUNT = gql`
  {
    pcnCount
  }
`;
